import makeActionCreator from './makeActionCreator';
import {
  BECOME_USER_DELEGATE,
  BECOME_USER_DELEGATE_DONE,
  BECOME_USER_DELEGATE_ERROR,
  BECOME_USER_DELEGATE_LOADING,
  BECOME_USER_DELEGATE_SUCCESS,
  FETCH_USER_DELEGATE,
  FETCH_USER_DELEGATE_DONE,
  FETCH_USER_DELEGATE_ERROR,
  FETCH_USER_DELEGATE_LOADING,
  FETCH_USER_DELEGATE_SUCCESS
} from './actionTypes';

// Create your Action Creators here...
export const fetchUserDelegate = makeActionCreator(FETCH_USER_DELEGATE);
export const fetchUserDelegateLoading = makeActionCreator(FETCH_USER_DELEGATE_LOADING);
export const fetchUserDelegateSuccess = makeActionCreator(FETCH_USER_DELEGATE_SUCCESS, 'delegates');
export const fetchUserDelegateError = makeActionCreator(FETCH_USER_DELEGATE_ERROR, 'error');
export const fetchUserDelegateDone = makeActionCreator(FETCH_USER_DELEGATE_DONE);

export const becomeUserDelegate = makeActionCreator(BECOME_USER_DELEGATE, 'userId');
export const becomeUserDelegateLoading = makeActionCreator(BECOME_USER_DELEGATE_LOADING);
export const becomeUserDelegateSuccess = makeActionCreator(BECOME_USER_DELEGATE_SUCCESS, 'user');
export const becomeUserDelegateError = makeActionCreator(BECOME_USER_DELEGATE_ERROR, 'error');
export const becomeUserDelegateDone = makeActionCreator(BECOME_USER_DELEGATE_DONE);
